/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { ArtifactFormComponentProps } from '@/features/artifacts/components/ArtifactForm';
import { ArtifactFormOverrides } from '@/features/artifacts/components/ArtifactForm/ArtifactForm.types';
import { useArtifactFormConfig } from '@/features/artifacts/hooks/useArtifactFormConfig';

import ArtifactBaseForm from '@/features/artifacts/components/ArtifactBaseForm';
import ArtifactFormProvider, {
  ArtifactFormConsumer,
} from '@/features/artifacts/providers/ArtifactFormProvider';

const ProcedimentoFormDefault: ArtifactFormOverrides = [
  { name: 'reasonCode', label: 'Indicação clínica', required: true },
  { name: 'bodySite', label: 'Local do Corpo' },
  { name: 'orderDetail', label: 'Observações' },
  { name: 'opmes', label: 'OPME Sugeridos' },
];

export type FormProcedimentoProps = ArtifactFormComponentProps;

const FormProcedimento: React.FC<FormProcedimentoProps> = ({
  resource,
  onSubmit,
  onSubmitError,
  onCancel,
  disabled = false,
  loading = false,
  readOnly = false,
}) => {
  const form = useArtifactFormConfig('procedimento', ProcedimentoFormDefault);

  return (
    <ArtifactFormProvider form={form} resource={resource}>
      <ArtifactFormConsumer>
        {({ handleResourceSubmit }) => (
          <ArtifactBaseForm
            form={form}
            loading={loading}
            disabled={disabled}
            readOnly={readOnly}
            onCancel={() => onCancel(resource)}
            onSubmit={handleResourceSubmit(onSubmit, onSubmitError)}
          />
        )}
      </ArtifactFormConsumer>
    </ArtifactFormProvider>
  );
};

export default FormProcedimento;
